import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiResponse } from './models/api-response';
import { GenericItem } from './models/generic-item';
import { GenericList } from './models/generic-list';
import { MaintArea } from './models/maint-area';

import { ServicerProvider } from './servicer';

const BASE_URL = '/v2/system/maint/areas';

/**
 * [システム] [メンテナンス] エリア のプロバイダー.
 */
@Injectable()
export class SystemMaintAreasServiceProvider {

  constructor(
    private servicer: ServicerProvider
  ) { }

  /**
   * エリア一覧取得処理.
   * 
   * @returns Observable<GenericList<MaintArea>>
   */
  list(): Observable<GenericList<MaintArea>> {
    return this.servicer.list(BASE_URL);
  }

  /**
   * エリア取得処理.
   * 
   * @param id エリアID
   * @returns Observable<MaintArea>
   */
  get(id: number): Observable<GenericItem<MaintArea>> {
    const url = `${ BASE_URL }/${ id }`;
    return this.servicer.get<GenericItem<MaintArea>>(url);
  }

  /**
   * エリア保存処理.
   *
   * @param data 入力データ
   * @returns Observable<ApiResponse>
   */
  patch(data: MaintArea): Observable<ApiResponse> {
    const url = `${ BASE_URL }/${ data.id }`;
    return this.servicer.patch<MaintArea, ApiResponse>(url, data);
  }
}



// WEBPACK FOOTER //
// ./src/providers/servicer/system-maint-areas-service.ts